module.exports = __webpack_public_path__ + "img/newgen-graphic.77d0da56.png";